import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=06c11c00&scoped=true"
import script from "./choose.vue?vue&type=script&lang=js"
export * from "./choose.vue?vue&type=script&lang=js"
import style0 from "./choose.vue?vue&type=style&index=0&id=06c11c00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c11c00",
  null
  
)

export default component.exports